import axios from '@/config/axios'


const baseUrl = "/v1/api/mg/property";
/**
 *
 * @param query
 * @returns {*}
 */
export const property = (query) => axios.get(`/v1/api/mg/property`, {
    params: query, headers: {
        "request": "dto"
    }
})


/**
 * 保存社区
 * @param property 社区内容
 */
export const saveProperty = (property) => axios.post(`/v1/api/mg/property`, property)

/**
 * 更新
 * @param property 社区信息
 * @returns {AxiosPromise<any> | IDBRequest<IDBValidKey> | Promise<void>}
 */
export const updateProperty = (property) => axios.put(`/v1/api/mg/property/${property.id}`, property)

export const propertyDetail = (pid) => axios.get(`${baseUrl}/${pid}`);


const accessBase = '/v1/api/mg/access'

export const accessListExport = (query) => axios.get(`${accessBase}`, {
    params: query, headers: {
        Accept: "application/vnd.ms-excel"
    },
    responseType: 'arraybuffer'
})
export const accessList = (query) => axios.get(`${accessBase}`, {
    params: query, headers: {
        "request": "dto"
    }
})


const estatePaymentAPI = "/v1/api/mg/e-payment"


export const estatePayments = (query) => axios.get(`${estatePaymentAPI}`, {
    params: query, headers: {
        "request": "dto"
    }
})

export const exportEstatePayments = (query) => axios.get(`${estatePaymentAPI}`, {
    params: query,
    headers: {
        Accept: "application/vnd.ms-excel"
    },
    responseType: 'arraybuffer'
})


const blackListBase = '/v1/api/mg/blacks'


export const blacks = (query) => axios.get(`${blackListBase}`, {
    params: query, headers: {
        "request": "dto"
    }
})


export const addToBlacks = (data) => axios.post(`${blackListBase}`, data)


export const updateBlacks = (data) => axios.put(`${blackListBase}`, data)


export const doorCom = () => axios.get('/v1/api/mg/doorCom')


/**
 * 获取注册模板
 * @returns {*}
 */
export const registerTpl = () => axios.get(`/v1/api/mg/registerTpl`)


/**
 *
 * @param query
 * @returns {*}
 */
export const registerRecords = (query) => axios.get(`/v1/api/mg/registerRecords`, {
    params: query
})


/**
 *
 * @param query
 * @returns {*}
 */
export const registerRecordsByConcierge = (query) => axios.get(`/v1/api/mg/conciergeRecords`, {params: query})


/**
 *
 * @param id
 * @returns {*}
 */
export const registerRecordsByConciergeUpdate = (id) => axios.patch(`/v1/api/mg/conciergeRecords/${id}`)


export const updateRegisterRecords = (data) => axios.put(`/v1/api/mg/registerRecords/${data.id}`, data)


// export const accessListExport = (query) => axios.get(`${accessBase}`, {
//     params: query, headers: {
//         Accept: "application/vnd.ms-excel"
//     },
//     responseType: 'arraybuffer'
// })
